import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#050505] min-h-screen text-white">
      <Navbar />
      <div className="max-w-4xl mx-auto px-6 py-40">
        <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tighter mb-12 italic">
          Terms of <span className="text-[#DFFF00]">Service.</span>
        </h1>
        
        <div className="space-y-12 text-slate-400 leading-relaxed text-lg font-medium">
          <section>
            <h2 className="text-white text-xl font-black uppercase tracking-widest mb-4">01. Service Description</h2>
            <p>
              DubtrackFM provides industrial-scale social media distribution infrastructure and AI-generated creative assets. Our services involve the deployment of account nodes and the generation of media variations for algorithmic saturation. 
            </p>
          </section>

          <section>
            <h2 className="text-white text-xl font-black uppercase tracking-widest mb-4">02. Account Nodes</h2>
            <p>
              All account nodes provided by DubtrackFM are built from scratch (Zero-Identity Protocol). These accounts do not have pre-established authority. The client acknowledges that algorithmic performance varies and the growth of these nodes is subject to platform-specific variables.
            </p>
          </section>

          <section>
            <h2 className="text-white text-xl font-black uppercase tracking-widest mb-4">03. User Obligations</h2>
            <p>
              Clients must provide accurate operational data for vetting. Exploitation of our infrastructure for illegal activities, hate speech, or prohibited content as defined by target platforms is strictly forbidden and will result in immediate termination of the protocol without refund.
            </p>
          </section>

          <section>
            <h2 className="text-white text-xl font-black uppercase tracking-widest mb-4">04. Limitation of Liability</h2>
            <p>
              DubtrackFM is not responsible for platform-level changes, algorithm updates, or account suspensions initiated by social media networks. We provide the infrastructure and assets; the final performance is subject to the platform's independent ecosystem.
            </p>
          </section>

          <p className="pt-12 border-t border-white/10 text-xs text-slate-600 font-black uppercase tracking-[0.4em]">
            Last Updated: {new Date().toLocaleDateString()} // PROTOCOL_V1.0
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}